import { Alert } from '@cmsgov/ds-medicare-gov';
import React from 'react';
import '../css/validation.alert.css';

interface ValidationAlertsProps {
    validationMessages: any[]
    heading?: string
    style?: React.CSSProperties
}

const ValidationAlerts = (props: ValidationAlertsProps) => {
    const getMessages = () => props.validationMessages.map((message, index) => <li key={`alert-${index}`}>{message}</li>);

    if (props.validationMessages.length === 0)
        return null;
    return <>
        <Alert
            heading={props.heading}
            headingId={'alertHeader'}
            role={'alert'}
            variation={'error'}
        >
            <ul>{getMessages()}</ul>
        </Alert>
    </>;
}

export default ValidationAlerts;